// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.view-mapping-dialog {
  display: flex;
  width: 100%;
  max-height: 90vh;
  flex-direction: column;
  overflow: hidden;
  background: var(--ca-surface, #fff);
  border-radius: var(--ca-radius-lg, 12px);
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.35rem 1.5rem 1.15rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(135deg, var(--ca-surface, #fff) 0%, var(--ca-surface-hover, #f8faff) 100%);
}

.dialog-title-block {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.9rem;
}

.title-icon {
  display: grid;
  width: 2.75rem;
  height: 2.75rem;
  flex: 0 0 2.75rem;
  place-items: center;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.3rem;
}

.eyebrow {
  margin: 0 0 0.2rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.dialog-header h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.asset-context {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
  margin: 0.35rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
}

.asset-name {
  font-weight: 650;
}

.context-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.asset-id {
  max-width: min(42vw, 32rem);
  overflow: hidden;
  color: var(--ca-text-muted, #8c96a8);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon-close {
  display: inline-grid;
  width: 2.2rem;
  height: 2.2rem;
  flex: 0 0 2.2rem;
  place-items: center;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-sm, 6px);
  background: transparent;
  color: var(--ca-text-tertiary, #6f7b91);
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}
.icon-close:hover {
  border-color: var(--ca-border-light, #e9edf3);
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-primary, #172033);
}
.icon-close:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}

.tabs-bar {
  display: flex;
  flex: 0 0 auto;
  gap: 0.4rem;
  padding: 0 1.5rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: var(--ca-surface, #fff);
}

.mapping-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  min-height: 3.25rem;
  padding: 0.85rem 0.9rem;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: var(--ca-text-secondary, #4b5870);
  font: inherit;
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}
.mapping-tab > i {
  font-size: 1rem;
}
.mapping-tab:hover {
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary, #0e2e80);
}
.mapping-tab:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: -3px;
}
.mapping-tab.active {
  border-bottom-color: var(--ca-primary, #0e2e80);
  color: var(--ca-primary, #0e2e80);
}

.tab-count {
  display: inline-flex;
  min-width: 1.35rem;
  height: 1.35rem;
  align-items: center;
  justify-content: center;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.68rem;
  font-weight: 700;
}

.mapping-tab.active .tab-count {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.dialog-body {
  min-height: 18rem;
  padding: 1.25rem 1.5rem 1rem;
  overflow: auto;
}

.panel-intro {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.1rem;
}
.panel-intro h3 {
  margin: 0 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 700;
}
.panel-intro p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.5;
}

.record-summary {
  flex: 0 0 auto;
  padding: 0.4rem 0.65rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.72rem;
  font-weight: 650;
  white-space: nowrap;
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(15rem, 1.5fr) minmax(12rem, 0.85fr) auto;
  gap: 0.7rem;
  margin-bottom: 1rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.55rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
}
.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.18rem rgba(40, 80, 173, 0.14);
  outline: 0;
}
.search-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.65rem;
  flex: 0 0 2.65rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}
.search-submit:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.45rem;
  padding: 0.55rem 0.9rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
}
.btn-primary:focus-visible,
.btn-secondary:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}
.btn-primary:disabled,
.btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}
.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.table-region app-main-table {
  display: block;
  min-width: 0;
}

.inline-loading {
  display: flex;
  min-height: 4rem;
  align-items: center;
  gap: 0.6rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.84rem;
}

.inline-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin: 0.5rem 0;
  padding: 0.75rem 0.9rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.inline-retry {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.state-panel,
.no-results {
  display: flex;
  min-height: 13rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 1.5rem 1rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}
.state-panel > i,
.no-results > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.8rem;
}
.state-panel h3,
.no-results h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 700;
}
.state-panel p,
.no-results p {
  max-width: 30rem;
  margin: 0 0 0.35rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.84rem;
  line-height: 1.55;
}

.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.loading-spinner {
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: view-mapping-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
}

.list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.pagination-summary {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.85rem 1.5rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  background: var(--ca-surface-hover, #f8faff);
}

@keyframes view-mapping-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 760px) {
  .dialog-header {
    padding: 1rem;
  }
  .tabs-bar {
    padding-inline: 0.75rem;
  }
  .mapping-tab {
    flex: 1 1 0;
    gap: 0.35rem;
    padding-inline: 0.4rem;
    font-size: 0.78rem;
  }
  .dialog-body {
    padding: 1rem;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .clear-search {
    justify-self: start;
  }
  .list-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .list-footer app-pagination {
    align-self: flex-end;
    max-width: 100%;
  }
  .dialog-footer {
    padding: 0.75rem 1rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
/* Security-zone drill-down view */
.drilldown-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0 0 1.15rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-hover, #f8faff);
}

.back-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.back-button:hover {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
}
.back-button:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}

.drilldown-context {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.12rem;
  text-align: right;
}
.drilldown-context strong {
  max-width: 100%;
  overflow: hidden;
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drilldown-kicker {
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.drilldown-id {
  max-width: min(48vw, 32rem);
  overflow: hidden;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.7rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dialog-footer {
  gap: 0.65rem;
}

@media (max-width: 560px) {
  .drilldown-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .drilldown-context {
    align-items: flex-start;
    max-width: 100%;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/data-asset-mapping/view-mapping/view-mapping.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mCAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,+BAAA;EACA,wDAAA;EACA,sGAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;AACF;;AAEA;EAAc,gBAAA;AAEd;;AADA;EAAqB,oCAAA;AAKrB;;AAJA;EACE,2BAAA;EACA,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,mBAAA;AAOF;;AAJA;EACE,oBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,uCAAA;EACA,uBAAA;EACA,uCAAA;EACA,eAAA;EACA,kFAAA;AAOF;AALE;EACE,6CAAA;EACA,2CAAA;EACA,sCAAA;AAOJ;AAJE;EACE,mDAAA;EACA,mBAAA;AAMJ;;AAFA;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,wDAAA;EACA,mCAAA;AAKF;;AAFA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,uBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kFAAA;AAKF;AAHE;EAAM,eAAA;AAMR;AAJE;EACE,4CAAA;EACA,iCAAA;AAMJ;AAHE;EACE,mDAAA;EACA,oBAAA;AAKJ;AAFE;EACE,+CAAA;EACA,iCAAA;AAIJ;;AAAA;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,2CAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,6CAAA;EACA,iCAAA;AAGF;;AAAA;EACE,iBAAA;EACA,4BAAA;EACA,cAAA;AAGF;;AAAA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AAGF;AADE;EACE,mBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAGJ;AAAE;EACE,SAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,cAAA;EACA,uBAAA;EACA,iDAAA;EACA,oBAAA;EACA,4CAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sEAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EAAgB,aAAA;EAAe,YAAA;EAAc,oBAAA;AAI7C;;AAHA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,kBAAA;AAMF;AAJE;EACE,4CAAA;EACA,iDAAA;EACA,UAAA;AAMJ;AAHE;EAAiB,oCAAA;AAMnB;;AAHA;EAAgC,0BAAA;EAA4B,6BAAA;AAQ5D;;AAPA;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,uCAAA;AAUF;AARE;EAAU,2CAAA;AAWZ;AAVE;EAAkB,mDAAA;EAAqD,mBAAA;AAczE;;AAXA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAcF;AAZE;;EAAkB,mDAAA;EAAqD,mBAAA;AAiBzE;AAhBE;;EAAa,YAAA;EAAc,mBAAA;AAqB7B;;AAlBA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AAqBF;AApBE;EAAyB,6CAAA;EAA+C,2CAAA;EAA6C,WAAA;AAyBvH;;AAtBA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AAyBF;AAxBE;EAAyB,wCAAA;EAA0C,4CAAA;AA4BrE;;AAzBA;EAAgB,YAAA;EAAc,gBAAA;AA8B9B;;AA7BA;EAA+B,cAAA;EAAgB,YAAA;AAkC/C;;AAhCA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;AAmCF;;AAhCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;AAmCF;;AAhCA;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAmCF;;AAhCA;;EAEE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,uCAAA;EACA,kBAAA;AAmCF;AAjCE;;EAAM,uCAAA;EAAyC,iBAAA;AAsCjD;AArCE;;EAAK,SAAA;EAAW,sCAAA;EAAwC,eAAA;EAAiB,gBAAA;AA4C3E;AA3CE;;EAAI,gBAAA;EAAkB,mBAAA;EAAqB,wCAAA;EAA0C,kBAAA;EAAoB,iBAAA;AAmD3G;;AAhDA;EAAmB,gCAAA;AAoDnB;;AAnDA;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iDAAA;AAsDF;;AApDA;EAAsB,WAAA;EAAa,YAAA;EAAc,iBAAA;AA0DjD;;AAxDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,qDAAA;AA2DF;;AAxDA;EAAsB,uCAAA;EAAyC,kBAAA;AA6D/D;;AA5DA;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,qDAAA;EACA,4CAAA;AA+DF;;AA5DA;EAA+B;IAAK,yBAAA;EAiElC;AACF;AAhEA;EACE;IAAiB,aAAA;EAmEjB;EAlEA;IAAY,uBAAA;EAqEZ;EApEA;IAAe,WAAA;IAAa,YAAA;IAAc,sBAAA;IAAwB,kBAAA;EA0ElE;EAzEA;IAAe,aAAA;EA4Ef;EA3EA;IAAkB,qCAAA;EA8ElB;EA7EA;IAAgB,mBAAA;EAgFhB;EA/EA;IAAe,oBAAA;IAAsB,sBAAA;EAmFrC;EAlFA;IAA8B,oBAAA;IAAsB,eAAA;EAsFpD;EArFA;IAAiB,qBAAA;EAwFjB;AACF;AAtFA;EACE;IAAyB,qCAAA;IAAuC,uCAAA;IAAyC,sCAAA;IAAwC,gCAAA;EA4FjJ;AACF;AA1FA,kCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,iDAAA;EACA,uCAAA;EACA,4CAAA;AA4FF;;AAzFA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,2CAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gEAAA;AA4FF;AA1FE;EACE,wCAAA;EACA,6CAAA;AA4FJ;AAzFE;EACE,mDAAA;EACA,mBAAA;AA2FJ;;AAvFA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AA0FF;AAxFE;EACE,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AA0FJ;;AAtFA;EACE,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAyFF;;AAtFA;EACE,2BAAA;EACA,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AAyFF;;AAtFA;EACE,YAAA;AAyFF;;AAtFA;EACE;IACE,uBAAA;IACA,sBAAA;EAyFF;EAtFA;IACE,uBAAA;IACA,eAAA;IACA,gBAAA;EAwFF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.view-mapping-dialog {\n  display: flex;\n  width: 100%;\n  max-height: 90vh;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--ca-surface, #fff);\n  border-radius: var(--ca-radius-lg, 12px);\n}\n\n.dialog-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.35rem 1.5rem 1.15rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: linear-gradient(135deg, var(--ca-surface, #fff) 0%, var(--ca-surface-hover, #f8faff) 100%);\n}\n\n.dialog-title-block {\n  display: flex;\n  min-width: 0;\n  align-items: flex-start;\n  gap: 0.9rem;\n}\n\n.title-icon {\n  display: grid;\n  width: 2.75rem;\n  height: 2.75rem;\n  flex: 0 0 2.75rem;\n  place-items: center;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.3rem;\n}\n\n.eyebrow {\n  margin: 0 0 0.2rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.dialog-header h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n}\n\n.asset-context {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n  margin: 0.35rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.8rem;\n}\n\n.asset-name { font-weight: 650; }\n.context-separator { color: var(--ca-text-muted, #8c96a8); }\n.asset-id {\n  max-width: min(42vw, 32rem);\n  overflow: hidden;\n  color: var(--ca-text-muted, #8c96a8);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.icon-close {\n  display: inline-grid;\n  width: 2.2rem;\n  height: 2.2rem;\n  flex: 0 0 2.2rem;\n  place-items: center;\n  border: 1px solid transparent;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: transparent;\n  color: var(--ca-text-tertiary, #6f7b91);\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    border-color: var(--ca-border-light, #e9edf3);\n    background: var(--ca-bg-secondary, #eef2f8);\n    color: var(--ca-text-primary, #172033);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ca-primary-light, #2850ad);\n    outline-offset: 2px;\n  }\n}\n\n.tabs-bar {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 0.4rem;\n  padding: 0 1.5rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: var(--ca-surface, #fff);\n}\n\n.mapping-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  min-height: 3.25rem;\n  padding: 0.85rem 0.9rem;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  background: transparent;\n  color: var(--ca-text-secondary, #4b5870);\n  font: inherit;\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;\n\n  > i { font-size: 1rem; }\n\n  &:hover {\n    background: var(--ca-surface-hover, #f8faff);\n    color: var(--ca-primary, #0e2e80);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ca-primary-light, #2850ad);\n    outline-offset: -3px;\n  }\n\n  &.active {\n    border-bottom-color: var(--ca-primary, #0e2e80);\n    color: var(--ca-primary, #0e2e80);\n  }\n}\n\n.tab-count {\n  display: inline-flex;\n  min-width: 1.35rem;\n  height: 1.35rem;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.mapping-tab.active .tab-count {\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.dialog-body {\n  min-height: 18rem;\n  padding: 1.25rem 1.5rem 1rem;\n  overflow: auto;\n}\n\n.panel-intro {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.1rem;\n\n  h3 {\n    margin: 0 0 0.25rem;\n    color: var(--ca-text-primary, #172033);\n    font-size: 1rem;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.82rem;\n    line-height: 1.5;\n  }\n}\n\n.record-summary {\n  flex: 0 0 auto;\n  padding: 0.4rem 0.65rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 999px;\n  background: var(--ca-surface-hover, #f8faff);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.72rem;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(15rem, 1.5fr) minmax(12rem, 0.85fr) auto;\n  gap: 0.7rem;\n  margin-bottom: 1rem;\n}\n\n.search-field { display: flex; min-width: 0; align-items: stretch; }\n.search-control {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.55rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.84rem;\n\n  &:focus {\n    border-color: var(--ca-input-focus, #2850ad);\n    box-shadow: 0 0 0 0.18rem rgba(40, 80, 173, 0.14);\n    outline: 0;\n  }\n\n  &::placeholder { color: var(--ca-text-muted, #8c96a8); }\n}\n\n.search-field .search-control { border-top-right-radius: 0; border-bottom-right-radius: 0; }\n.search-submit {\n  display: inline-grid;\n  width: 2.65rem;\n  flex: 0 0 2.65rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover { background: var(--ca-primary-dark, #0d2863); }\n  &:focus-visible { outline: 2px solid var(--ca-primary-light, #2850ad); outline-offset: 2px; }\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  min-height: 2.45rem;\n  padding: 0.55rem 0.9rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.82rem;\n  font-weight: 600;\n  white-space: nowrap;\n\n  &:focus-visible { outline: 2px solid var(--ca-primary-light, #2850ad); outline-offset: 2px; }\n  &:disabled { opacity: 0.6; cursor: not-allowed; }\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  &:hover:not(:disabled) { border-color: var(--ca-primary-dark, #0d2863); background: var(--ca-primary-dark, #0d2863); color: #fff; }\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n  &:hover:not(:disabled) { border-color: var(--ca-primary, #0e2e80); background: var(--ca-surface-hover, #f8faff); }\n}\n\n.table-region { min-width: 0; overflow-x: auto; }\n.table-region app-main-table { display: block; min-width: 0; }\n\n.inline-loading {\n  display: flex;\n  min-height: 4rem;\n  align-items: center;\n  gap: 0.6rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.84rem;\n}\n\n.inline-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  margin: 0.5rem 0;\n  padding: 0.75rem 0.9rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n}\n\n.inline-retry {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font-weight: 700;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.state-panel,\n.no-results {\n  display: flex;\n  min-height: 13rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  padding: 1.5rem 1rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n\n  > i { color: var(--ca-primary-light, #2850ad); font-size: 1.8rem; }\n  h3 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 1rem; font-weight: 700; }\n  p { max-width: 30rem; margin: 0 0 0.35rem; color: var(--ca-text-secondary, #4b5870); font-size: 0.84rem; line-height: 1.55; }\n}\n\n.error-state > i { color: var(--ca-danger, #dc3545); }\n.loading-spinner {\n  display: inline-block;\n  width: 1.8rem;\n  height: 1.8rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: view-mapping-spin 0.8s linear infinite;\n}\n.loading-spinner-sm { width: 1rem; height: 1rem; border-width: 2px; }\n\n.list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.pagination-summary { color: var(--ca-text-tertiary, #6f7b91); font-size: 0.75rem; }\n.dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0.85rem 1.5rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n  background: var(--ca-surface-hover, #f8faff);\n}\n\n@keyframes view-mapping-spin { to { transform: rotate(360deg); } }\n\n@media (max-width: 760px) {\n  .dialog-header { padding: 1rem; }\n  .tabs-bar { padding-inline: 0.75rem; }\n  .mapping-tab { flex: 1 1 0; gap: 0.35rem; padding-inline: 0.4rem; font-size: 0.78rem; }\n  .dialog-body { padding: 1rem; }\n  .search-toolbar { grid-template-columns: minmax(0, 1fr); }\n  .clear-search { justify-self: start; }\n  .list-footer { align-items: stretch; flex-direction: column; }\n  .list-footer app-pagination { align-self: flex-end; max-width: 100%; }\n  .dialog-footer { padding: 0.75rem 1rem; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; transition-duration: 0.01ms !important; scroll-behavior: auto !important; }\n}\n\n/* Security-zone drill-down view */\n.drilldown-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin: 0 0 1.15rem;\n  padding: 0.75rem 0.9rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-hover, #f8faff);\n}\n\n.back-button {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.6rem;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.82rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    border-color: var(--ca-primary, #0e2e80);\n    background: var(--ca-surface-active, #eef3ff);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ca-primary-light, #2850ad);\n    outline-offset: 2px;\n  }\n}\n\n.drilldown-context {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.12rem;\n  text-align: right;\n\n  strong {\n    max-width: 100%;\n    overflow: hidden;\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.84rem;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.drilldown-kicker {\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n}\n\n.drilldown-id {\n  max-width: min(48vw, 32rem);\n  overflow: hidden;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.7rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dialog-footer {\n  gap: 0.65rem;\n}\n\n@media (max-width: 560px) {\n  .drilldown-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .drilldown-context {\n    align-items: flex-start;\n    max-width: 100%;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
